// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2qIps","value":"styles_value__K7NM9"};